import type { FC } from 'react';
import type { IconProps } from './types';

const InfoSolid: FC<IconProps> = ({ color = 'currentColor', size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.75 12C22.75 17.937 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.937 1.25 12C1.25 6.06291 6.06294 1.24997 12 1.24997C17.9371 1.24997 22.75 6.06291 22.75 12ZM13 17L13 11H11L11 17H13ZM11 8.24997C11 8.80225 11.4477 9.24997 12 9.24997C12.5523 9.24997 13 8.80225 13 8.24997C13 7.69768 12.5523 7.24997 12 7.24997C11.4477 7.24997 11 7.69768 11 8.24997Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InfoSolid;
